<template>
  <div class="form-group">
    <input
      autocomplete="off"
      :class="{ valid: isValid }"
      v-if="type != 'textarea' && !value"
      @input="
        $emit('input', data, $event.target.value) &&
          handleInput($event.target, $event.target.value)
      "
      :type="type"
      class="form-control"
      :id="title"
      :required="required ? true : false"
    />
    <input
      autocomplete="off"
      :class="{ valid: isValid }"
      v-else-if="type != 'textarea' && value"
      @input="
        $emit('input', data, $event.target.value) &&
          handleInput($event.target, $event.target.value)
      "
      :type="type"
      class="form-control"
      :id="title"
      :value="value"
      :required="required ? true : false"
    />
    <textarea
      autocomplete="off"
      :class="{ valid: isValid }"
      v-else-if="type === 'textarea'"
      @input="
        $emit('input', data, $event.target.value) &&
          handleInput($event.target, $event.target.value)
      "
      class="form-control"
      :required="required ? true : false"
      v-model="value"
    ></textarea>
    <label class="placeholder" :for="title">{{ title }}</label>
  </div>
</template>

<!-- Script
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<script>
export default {
  name: "input-group",
  props: ["type", "title", "placeholder", "data", "required", "value"],
  data() {
    return {
      isValid: false,
    };
  },
  methods: {
    handleInput: function (input, value) {
      if (input.checkValidity() && value.length > 0) {
        this.isValid = true;
      } else {
        if (!this.value) {
          this.isValid = false;
        }
      }
    },
  },
  created() {
    this.isValid = true;
    if (this.value) {
      this.isValid = true;
    } else {
      this.isValid = false;
    }
  },
};
</script>

<style>
.form-control.invalid,
textarea.invalid {
  border: 1px solid red !important;
}
.form-control.invalid + label {
  color: red;
}
</style>
